import { render, staticRenderFns } from "./SdkMetadata.vue?vue&type=template&id=61496214&"
import script from "./SdkMetadata.vue?vue&type=script&lang=js&"
export * from "./SdkMetadata.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('61496214')) {
      api.createRecord('61496214', component.options)
    } else {
      api.reload('61496214', component.options)
    }
    module.hot.accept("./SdkMetadata.vue?vue&type=template&id=61496214&", function () {
      api.rerender('61496214', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Information/Metadata/SdkMetadata.vue"
export default component.exports